'use strict';

var base = require('base/product/base');
var slickConfigs = require('../config/slickConfigs');

/**
 * Init the product carousel using a predefined slick configuration
 */
function carouselInit() {
    // debugger;
    // if ($('.product-carousel').length) {
    //     if ($('.primary-images').hasClass('thumbs')) {
    //         $('.product-carousel').not('.slick-initialized').slick(slickConfigs.pdp);
    //
    //         $(window).on('resize.productcarousel', function () {
    //             if ($(window).width() < 768 && !$('.product-carousel').hasClass('slick-initialized')) {
    //                 $('.product-carousel').not('.slick-initialized').slick(slickConfigs.pdp);
    //             }
    //         });
    //     } else {
    //         $('.product-carousel').not('.slick-initialized').slick(slickConfigs.pdpSetAndBundle);
    //     }
    // }
}

var exportBase = $.extend({}, base, {
    carouselInit: carouselInit
});

module.exports = exportBase;
